export const Hype = [
  {
    artist: "Post Malone , Swae Lee",
    name: "SunFlower",
  },
  {
    artist: "Travis Scott",
    name: "Goosebumps",
  },
  {
    artist: "Travis Scott , Kid Cudi",
    name: "TheScotts",
  },
  {
    artist: "Post Malone , 21 Savage",
    name: "Rockstar",
  },
  {
    artist: "Imagine Dragons",
    name: "Natural",
  },
  {
    artist: "Lil Tjay",
    name: "F.N",
  },
  {
    artist: "Lil Baby",
    name: "DripTooHard",
  },
  {
    artist: "Linkin Park",
    name: "SomewhereIBelong",
  },

  {
    artist: "Imagine Dragons",
    name: "Radioactive",
  },
  {
    artist: "The Weekend",
    name: "StarBoy",
  },
  {
    artist: "Bad Wolves",
    name: "Zombie",
  },
  {
    artist: "Eminem , Royce Da 5'9 , White Gold ",
    name: "YouGonLearn",
  },

  {
    artist: "Linkin Park",
    name: "InTheEnd",
  },
  {
    artist: "SAINt JHN , Imanbek",
    name: "Roses",
  },
  {
    artist: "Imagine Dragons",
    name: "Believer",
  },
  {
    artist: "Lil Skies",
    name: "Riot",
  },
  {
    artist: "Roddy Ricch",
    name: "TheBox",
  },
  {
    artist: "Post Malone , Ty Dolla $ign",
    name: "Psycho",
  },
  {
    artist: "Lil Baby",
    name: "TheBiggerPicture",
  },
  {
    artist: "Eminem",
    name: "LoseYourself",
  },
  {
    artist: "Brennan Savage",
    name: "LookAtMeNow",
  },
  {
    artist: "Eminem , Juice WRLD",
    name: "Godzilla",
  },
  {
    artist: "Justin Bieber",
    name: "Sorry",
  },

  {
    artist: "Post Malone",
    name: "BetterNow",
  },

  {
    artist: "The Chainsmokers",
    name: "SickBoy",
  },
];

export const Pop = [
  {
    artist: "Post Malone",
    name: "Circles",
  },
  {
    artist: "Post Malone , Halsey",
    name: "DieForMe",
  },
  {
    artist: "Twenty One Pilots",
    name: "StressedOut",
  },
  {
    artist: "Twenty one pilots",
    name: "Chlorine",
  },
  {
    artist: "Eminem , Rihanna",
    name: "TheMonster",
  },
  {
    artist: "Linkin Park",
    name: "CastleOfGlass",
  },

  {
    artist: "Nirvana",
    name: "SmellsLikeTeenSpirit",
  },
  {
    artist: "League of legends",
    name: "Phoenix",
  },
  {
    artist: "Mehrad Hidden , Arash Dara",
    name: "Raha",
  },
  {
    artist: "Daya",
    name: "SitStillLookPretty",
  },
  {
    artist: "Mehrad Hidden",
    name: "Ejdeha",
  },
  {
    artist: "24kGoldn",
    name: "CityOfAngels",
  },
  {
    artist: "Ed Sheeran",
    name: "ShapeOfYou",
  },
  {
    artist: "Drake",
    name: "InMyFeelings",
  },
  {
    artist: "Post Malone , Ty Dolla $ign",
    name: "Psycho",
  },
  {
    artist: "Halsey",
    name: "Nightmare",
  },
  {
    artist: "juice wrld",
    name: "Smile",
  },
  {
    artist: "juice wrld",
    name: "Righteous",
  },
  {
    artist: "juice wrld",
    name: "Conversations",
  },
  {
    artist: "Travis Scott , Drake",
    name: "SickoMode",
  },
  {
    artist: "Sia",
    name: "Greatest",
  },
  {
    artist: "Camila Cabello , Young Thug",
    name: "Havana",
  },
  {
    artist: "The Chainsmokers , Daya",
    name: "DontLetMeDown",
  },
  {
    artist: "Alan Walker",
    name: "Faded",
  },
  {
    artist: "Maroon 5",
    name: "GirlsLikeYou",
  },
  {
    artist: "The Chainsmokers , Halsey",
    name: "Closer",
  },
  {
    artist: "Alan Walker",
    name: "Alone",
  },
  {
    artist: "Alan Walker",
    name: "Alone2",
  },
  {
    artist: "Alan Walker , Noah Cyrus ",
    name: "AllFallsDown",
  },
];

export const Chill = [
  {
    artist: "Hippie Sabotage",
    name: "DevilEyes",
  },
  {
    artist: "Billie Eilish , Khalid",
    name: "Lovely",
  },
  {
    artist: "Twocolors",
    name: "Lovefool",
  },
  {
    artist: "Lil Peep",
    name: "StarShopping",
  },
  {
    artist: "Wiz Khalifa , Charlie Puth",
    name: "SeeYouAgain",
  },
  {
    artist: "Metalica",
    name: "NothingElseMatters",
  },
  {
    artist: "Sia",
    name: "SoonWellBeFound",
  },
  {
    artist: "Lewis Capaldi",
    name: "SomeoneYouLoved",
  },
];

export const Chillup = [
  {
    artist: "xxxtentation",
    name: "Sad",
  },
  {
    artist: "xxxtentation",
    name: "NumbThePain",
  },
  {
    artist: "xxxtentation",
    name: "Changes",
  },
  {
    artist: "xxxtentation",
    name: "JocelynFlores",
  },
  {
    artist: "xxxtentation",
    name: "Moonlight",
  },
  {
    artist: "Trevor Daniel",
    name: "Falling",
  },
  {
    artist: "xxxtentation",
    name: "Triumph",
  },
  {
    artist: "xxxtentation",
    name: "Limbo",
  },
  {
    artist: "xxxtentation",
    name: "KillMyVibe",
  },
  {
    artist: "Daya",
    name: "Insomnia",
  },
  {
    artist: "Breaking Benjamin",
    name: "SoCold",
  },
  {
    artist: "xxxtentation",
    name: "Hope",
  },
  {
    artist: "xxxtentation",
    name: "Bad",
  },

  {
    artist: "Linkin Park",
    name: "Numb",
  },
];
